<div>{{ currentLength }} / {{ maxLength }}</div>
